type TokenGetter = () => string | null | undefined;

let _tokenGetter: TokenGetter | null = null;

export function registerTokenGetter(getter: TokenGetter): void {
  _tokenGetter = getter;
}

export function getAccessToken(): string | null {
  if (!_tokenGetter) return null;
  return _tokenGetter() ?? null;
}
